export function entityToStore(entity) {
  return entity.charAt(0).toLowerCase() + entity.slice(1);
}
